import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomSingleSelect } from "@ippon/shared-components";
import type { Control, FieldErrors } from "react-hook-form";
import { getEmployeeNames } from "@/store/employeeSlice";
import type { AppDispatch, RootState } from "@/store";

interface Props {
  label?: string;
  name: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  isRequired?: boolean;
  labelWidth?: string;
  inputWidth?: string;
}

const EmployeeSelect: React.FC<Props> = ({
  label = "管理責任者",
  name,
  control,
  errors,
  isRequired,
  labelWidth,
  inputWidth,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const employees = useSelector(
    (s: RootState) => (s.employees.names.data ?? []) as any[],
  );

  useEffect(() => {
    if (employees.length === 0) {
      dispatch(getEmployeeNames({}));
    }
  }, [dispatch, employees.length]);

  const options = useMemo(
    () => [
      // 先頭に「指定なし」を入れて、選ぶと値を空に戻せるようにする
      { label: "指定なし", value: "" },
      ...employees.map((e) => {
        const fullName =
          `${e.last_name ?? ""} ${e.first_name ?? ""}`.trim() ||
          e.name ||
          e.mail_address ||
          "";
        return { label: fullName, value: String(e.id ?? e.employee_id ?? "") };
      }),
    ],
    [employees],
  );

  return (
    <CustomSingleSelect
      label={label}
      name={name}
      control={control}
      errors={errors}
      options={options}
      isRequired={isRequired}
      labelWidth={labelWidth}
      inputWidth={inputWidth}
    />
  );
};

export default EmployeeSelect;
